var _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuteAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.86,3.69h-.65a2.22,2.22,0,0,0-1.58.66L6,7H4.23A2.24,2.24,0,0,0,2,9.24v5.52A2.24,2.24,0,0,0,4.23,17H6l2.67,2.66a2.22,2.22,0,0,0,1.58.66h.65a2.24,2.24,0,0,0,2.23-2.24V5.93A2.24,2.24,0,0,0,10.86,3.69Zm0,14.35h-.63L7.57,15.38A2.3,2.3,0,0,0,6,14.73l-1.72,0,0-5.49H6a2.25,2.25,0,0,0,1.58-.65L10.21,6h.62Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "22 9.78 20.43 8.21 18.21 10.43 15.99 8.21 14.42 9.78 16.64 12 14.42 14.22 15.99 15.79 18.21 13.57 20.43 15.79 22 14.22 19.78 12 22 9.78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteAll);
export default __webpack_public_path__ + "static/media/mute-all.159e858e7c9c215d5b91ae2f4cc2cfeb.svg";
export { ForwardRef as ReactComponent };